// frontend/src/utils/uploadFile.js
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../configs/firebaseStorage';

export const uploadFile = async (file, path) => {
  try {
    /*/ Check if user is authenticated
    if (!auth.currentUser) {
      throw new Error('User must be logged in to upload files');
    }*/

    // Generate unique filename
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    const uniqueFilename = `${timestamp}-${Math.random().toString(36).substring(2, 9)}.${fileExtension}`;
    const storagePath = `${path}/${uniqueFilename}`;

    // Create reference and upload
    const storageRef = ref(storage, storagePath);
    await uploadBytes(storageRef, file);
    
    // Get download URL
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
    
  } catch (error) {
    console.error('Error uploading file:', error);
    throw new Error(`File upload failed: ${error.message}`);
  }
};